import React, { useEffect, useState } from 'react';
import { getEventos } from '../api';
import { isEventoClosed } from '../utils/eventoStatus';
import EventoCard from '../components/EventoCard';

export default function EventosEncerrados() {
  const [eventos, setEventos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getEventos().then(data => {
      setEventos(data);
      setLoading(false);
    }).catch(err => {
      console.error(err);
      setLoading(false);
    });
  }, []);

  const encerrados = eventos
    .filter(isEventoClosed)
    .sort((a, b) => new Date(b.data_evento) - new Date(a.data_evento));

  return (
    <div className="flex-grow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="mb-8">
          <h3 className="text-2xl font-bold text-gray-900 tracking-tight">Eventos Encerrados</h3>
          <p className="text-gray-500 text-sm mt-1">Eventos cujas inscrições já foram finalizadas.</p>
        </div>

        {loading ? (
          <div className="text-center py-16 text-gray-400">Carregando eventos...</div>
        ) : encerrados.length === 0 ? (
          <div className="text-center py-16 text-gray-400">Nenhum evento encerrado até o momento.</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {encerrados.map(evento => (
              <EventoCard key={evento.id} evento={evento} closed />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
